import {
  BffChargeTimeConfigurationResponse,
  BffTrimData,
  ChargeTimeTrimModel,
} from '@volkswagen-onehub/whitelabel-e-mobility-data-types';
import {useConfiguration} from '@volkswagen-onehub/whitelabel-e-mobility-commons';

export function useTrims(): BffTrimData<ChargeTimeTrimModel>[] {
  const configurations = useConfiguration<BffChargeTimeConfigurationResponse>();

  return configurations.trims;
}
